export default "__VITE_ASSET__CSbYATWf__"